<template>
  <v-dialog :value="active" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('Contact.Form.header')}}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="contactForm" v-model="isValid">
          <v-row>
            <v-col cols="12">
              <v-text-field 
                :label="$t('Contact.Form.subject')" 
                v-model="subject" 
                :error-messages="subjectErrors"
                required
                :hint="$t('Contact.Form.subjectHint')"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                :label="$t('Contact.Form.contents')" 
                :error-messages="contentErrors"
                required
                v-model="content"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">{{$t('Global.Action.close')}}</v-btn>
        <v-btn color="primary darken-1" text @click="send" :loading="sending">{{$t('Global.Action.send')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import meService from '@/services/me'
export default {
  name: "TheContactModal",
  mixins: [validationMixin],
  data: () => ({
    subject: '',
    content: '',
    sending: false,
    isValid: false
  }),
  validations: {
    subject: { required },
    content: { required }
  },
  computed: {
    ...mapState('contact', [
      'active'
    ]),
    subjectErrors () {
      const errors = []
      if (!this.$v.subject.$dirty) return errors
      !this.$v.subject.required && errors.push(this.$t('Contact.Form.subjectRequired'))
      return errors
    },
    contentErrors () {
      const errors = []
      if (!this.$v.content.$dirty) return errors
      !this.$v.content.required && errors.push(this.$t('Contact.Form.contentsRequired'))
      return errors
    }
  },
  methods: {
    ...mapMutations('contact', [
      'showModal',
      'closeModal'
    ]),
    close () {
      this.subject = ''
      this.content = ''
      this.$v.$reset()
      this.closeModal()
    },
    async send () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.sending) {
        this.sending = true
        try {
          await meService.sendContactEmail(this.subject, this.content)
          this.$store.dispatch('successMessage', this.$t('Contact.Message.success'))
        } catch (error) {
          this.$store.dispatch('errorMessage', this.$t('Contact.Message.failed'))
          this.sending = false
        }
        
        this.sending = false
        this.close()
      }
    }
  }
}
</script>
